module.exports = __webpack_public_path__ + "img/e.470071e4.jpg";